import script from "./CollapsibleContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleContent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__